import React from 'react'
import { Grid, Chip, Typography } from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import { Sync as RefreshIcon } from '@the-platform-group/component-library/Icons'
import { MERGE_STATUS, MERGE_STATUS_OPTIONS } from '../../constants'

const STATUS_LABELS = MERGE_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label
  return acc
}, {})

const STATUS_COLORS = {
  [MERGE_STATUS.IN_PROGRESS]: 'caution',
  [MERGE_STATUS.COMPLETED]: 'success',
  [MERGE_STATUS.FAILED]: 'error',
}

const MergeStatusCell = ({ status, onRetry }) => {
  const statusColor = STATUS_COLORS[status] || 'default'
  const statusLabel = STATUS_LABELS[status] || status

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <Chip label={statusLabel} color={statusColor} size="small" variant="outlined-filled" />
      </Grid>
      {status === MERGE_STATUS.FAILED && onRetry && (
        <Grid item>
          <Button
            variant="text"
            size="small"
            startIcon={<RefreshIcon fontSize="small" />}
            onClick={onRetry}
          >
            <Typography variant="body2">Retry</Typography>
          </Button>
        </Grid>
      )}
    </Grid>
  )
}

export default MergeStatusCell
